import { Capacitor } from '@capacitor/core';

/**
 * Native builds pick their API URL from VITE_CAPACITOR_API_URL, set per mode:
 * .env has http://10.0.2.2:3000 (host machine as seen from the Android emulator)
 * and .env.production has the production API, so `npm run build` produces an
 * APK pointing at production without any code changes. Override ad hoc with
 * e.g. `VITE_CAPACITOR_API_URL=http://192.168.1.55:3000 npm run build` (a
 * physical device needs your computer's LAN IP instead of 10.0.2.2).
 */
const DEFAULT_CAPACITOR_API_URL = 'https://api.elkmoney.com';

export function getBaseUrl(): string {
	const baseUrl = import.meta.env.VITE_API_URL;
	const capacitorBaseUrl = import.meta.env.VITE_CAPACITOR_API_URL || DEFAULT_CAPACITOR_API_URL;

	return Capacitor.getPlatform() === 'web' ? baseUrl : capacitorBaseUrl;
}
